"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
var react_apollo_1 = require("react-apollo");
var react_router_dom_1 = require("react-router-dom");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var program_card_1 = require("../../components/program/program-card");
var GqlPrograms = require("../../core/gql/queries/programs");
var ProgramList = function (_a) {
    var _b;
    var orgId = _a.orgId;
    var renderLoading = function () {
        return (React.createElement(teamsnap_ui_1.PanelRow, { mods: "u-textCenter" },
            React.createElement("div", { className: "Loader-indicator" },
                React.createElement("span", { className: "SpinAnimation" }),
                React.createElement("div", { className: "Loader-indicatorText" }, "Loading programs..."))));
    };
    var renderEmpty = function () {
        return (React.createElement(teamsnap_ui_1.PanelRow, { mods: "u-textCenter" },
            React.createElement("h4", null,
                "No programs for this organization currently exist.\u00A0\u00A0",
                React.createElement(react_router_dom_1.Link, { to: "/organizations/" + orgId + "/programs/new" },
                    React.createElement(teamsnap_ui_1.Button, { color: "primary", icon: "plus", iconPosition: "left" }, "Create Program")))));
    };
    var renderProgram = function (program) {
        return React.createElement(program_card_1.default, { key: program.id, program: program });
    };
    var queryPrograms = react_apollo_1.useQuery(GqlPrograms.QUERY, { variables: { organizationId: orgId } });
    if (queryPrograms.loading) {
        return renderLoading();
    }
    if (queryPrograms.error) {
        return React.createElement("div", null, "Unable to load your programs. Please try refreshing the page.");
    }
    if (((_b = queryPrograms.data) === null || _b === void 0 ? void 0 : _b.programs.length) > 0) {
        return (React.createElement(React.Fragment, null, lodash_1.sortBy(queryPrograms.data.programs, ["name"]).map(function (program) { return renderProgram(program); })));
    }
    return renderEmpty();
};
exports.default = ProgramList;
//# sourceMappingURL=program-list.js.map